// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolNodeId } from './BrewcontrolNode';
import { brewcontrolRunSyncStatusEnum } from './BrewcontrolRunSyncStatusEnum';
import { brewcontrolWorkspaceId } from './BrewcontrolWorkspace';
import { brewcontrolRunStateEnum } from './BrewcontrolRunStateEnum';
import { z } from 'zod';
export const brewcontrolRunId = (z.number());
export const brewcontrolRun = z.object({
    id: brewcontrolRunId,
    node_id: brewcontrolNodeId,
    bc_run_id: z.string(),
    started_at: z.date(),
    ended_at: z.date().nullable(),
    created_at: z.date(),
    sync_status: brewcontrolRunSyncStatusEnum,
    telemetry_next_us: z.string(),
    workspace_id: brewcontrolWorkspaceId.nullable(),
    state: brewcontrolRunStateEnum,
    created_at_node: z.date().nullable(),
});
export const brewcontrolRunInitializer = z.object({
    id: brewcontrolRunId.optional(),
    node_id: brewcontrolNodeId,
    bc_run_id: z.string(),
    started_at: z.date().optional(),
    ended_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    sync_status: brewcontrolRunSyncStatusEnum.optional(),
    telemetry_next_us: z.string().optional(),
    workspace_id: brewcontrolWorkspaceId.optional().nullable(),
    state: brewcontrolRunStateEnum.optional(),
    created_at_node: z.date().optional().nullable(),
});
export const brewcontrolRunMutator = z.object({
    id: brewcontrolRunId.optional(),
    node_id: brewcontrolNodeId.optional(),
    bc_run_id: z.string().optional(),
    started_at: z.date().optional(),
    ended_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    sync_status: brewcontrolRunSyncStatusEnum.optional(),
    telemetry_next_us: z.string().optional(),
    workspace_id: brewcontrolWorkspaceId.optional().nullable(),
    state: brewcontrolRunStateEnum.optional(),
    created_at_node: z.date().optional().nullable(),
});
//# sourceMappingURL=BrewcontrolRun.js.map